import React from 'react';
import parse from 'html-react-parser';

export default function OptionEta({
  durationTitle,
  durationValue,
  durationSuffix,
}) {
  return (durationValue !== undefined && (
    <div className="app-option-duration">
      {durationTitle && (<div className="app-option-duration-label">{parse(durationTitle)}</div>)}
      <div className="app-option-duration-value">
        ~{durationValue} {durationSuffix && parse(durationSuffix)}
      </div>
    </div>
  ))
};
